import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Sort} from '@angular/material/sort';

@Injectable({
    providedIn: 'root'
})
export class ListService {

    /**
     * Mock from API
     */
    getColumns(): Observable<string[]> {
        const str = localStorage.getItem('lybox_columns');
        if (str === '' || str === null) {
            return of(null);
        }
        const cols = JSON.parse(str) as string[];

        return of(cols);
    }

    updateColumns(cols: string[]) {
        localStorage.setItem('lybox_columns', JSON.stringify(cols));
    }

    getSort(): Observable<Sort> {
        const str = localStorage.getItem('lybox_sort');
        if (str === '' || str === null) {
            return of(null);
        }
        const cols = JSON.parse(str) as Sort;

        return of(cols);
    }

    updateSort(sort: Sort) {
        localStorage.setItem('lybox_sort', JSON.stringify(sort));
    }
}

